import { useFormik } from 'formik';
import { Input } from 'shared-components';
import { Label } from 'shared-components';
import { FormGroup } from 'shared-components';
import styles from './new-field-form.module.css';
import { FieldType, IFormField } from '@topshots/core-models';
import * as yup from 'yup';
import { useAppDispatch } from '../../app/hooks';
import { close } from '../modal/modalSlice';
import { Select } from 'shared-components';
import { Checkbox } from 'shared-components';
import { Button } from 'shared-components';
import { FormLayout } from 'shared-components';

export const NewFieldForm = ({
  onFieldCreated,
}: {
  onFieldCreated: (field: Partial<IFormField>) => void;
}) => {
  const dispatch = useAppDispatch();
  const { handleSubmit, getFieldProps } = useFormik<Partial<IFormField>>({
    initialValues: {
      id: '',
      label: '',
      type: FieldType.Text,
      required: false,
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      id: yup.string().required(),
      label: yup.string().required(),
      type: yup.mixed<FieldType>().oneOf(Object.values(FieldType)),
      required: yup.boolean(),
    }),
    onSubmit: async (values) => {
      onFieldCreated(values);
      dispatch(close());
    },
  });

  return (
    <form onSubmit={handleSubmit}>
      <FormLayout className={styles.fieldInputs}>
        <FormGroup>
          <Label htmlFor="fieldName">Field Name</Label>
          <Input {...getFieldProps('id')} id="fieldName" />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="fieldLabel">Field Label</Label>
          <Input {...getFieldProps('label')} id="fieldLabel" />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="fieldType">Type</Label>
          <Select {...getFieldProps('type')} id="fieldType">
            <option value="text">Text</option>
            <option value="number">Number</option>
            <option value="select">Select</option>
            <option value="checkbox">Checkbox</option>
            <option value="textarea">Text Area</option>
          </Select>
        </FormGroup>
        <FormGroup>
          <Checkbox
            label="Required"
            type="checkbox"
            id="fieldRequired"
            {...getFieldProps('required')}
          />
        </FormGroup>
        <FormGroup>
          <Button type="submit">Add Field</Button>
        </FormGroup>
      </FormLayout>
    </form>
  );
};
